const VISIBLE_REPLACED_ELEMENTS =
  'img, video, audio, iframe, object, embed, svg, canvas, table, hr, input, math, .widget-placeholder';

const hasVisibleContent = (node) => {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.nodeValue.replace(/\u00a0/g, ' ').trim().length > 0;
  }

  if (node.nodeType !== Node.ELEMENT_NODE) return false;

  if (['STYLE', 'SCRIPT', 'TEMPLATE', 'BR'].includes(node.tagName)) {
    return false;
  }

  if (node.matches(VISIBLE_REPLACED_ELEMENTS)) return true;

  return [...node.childNodes].some(hasVisibleContent);
};

const isRemovableEmptyParagraph = (node) => {
  if (node.nodeType !== Node.ELEMENT_NODE || node.tagName !== 'P') {
    return false;
  }

  if (node.querySelector('style, script, template')) return false;

  return !hasVisibleContent(node);
};

/**
 * Removes editor-only padding around a multiple-choice answer while leaving
 * rich content and intentional spacing inside the answer untouched.
 */
export const normalizeMultipleChoiceAnswerHtml = (html) => {
  if (typeof html !== 'string' || !html.trim()) return html || '';

  const root = document.createElement('div');
  root.innerHTML = html;

  const nodes = [...root.childNodes];
  const visibleIndexes = nodes.reduce((indexes, node, index) => {
    if (hasVisibleContent(node)) indexes.push(index);
    return indexes;
  }, []);

  if (!visibleIndexes.length) return html;

  const firstVisibleIndex = visibleIndexes[0];
  const lastVisibleIndex = visibleIndexes[visibleIndexes.length - 1];

  nodes.forEach((node, index) => {
    if (
      (index < firstVisibleIndex || index > lastVisibleIndex) &&
      isRemovableEmptyParagraph(node)
    ) {
      node.remove();
    }
  });

  return root.innerHTML;
};
